import { DocumentPanel } from '../../components/DocumentPanel';
import { GeologyReport } from '../../components/GeologyReport';
import { ProgressChart } from '../../components/ProgressChart';
import type { Dashboard as DashboardData } from '../../lib/types';

export function DashboardScreen({ data }: { data: DashboardData }) {
  return (
    <div className="panelgrid">
      <DocumentPanel doc={data.documents[0]} onPrev={() => undefined} onNext={() => undefined}>
        <GeologyReport title={data.documents[0].title} />
      </DocumentPanel>

      <DocumentPanel doc={data.documents[1]} onPrev={() => undefined} onNext={() => undefined}>
        <ProgressChart title={data.well.name} kpis={data.kpis} />
      </DocumentPanel>
    </div>
  );
}
